import React from 'react'
import {injectIntl} from 'react-intl'
import FormControl from '@mui/material/FormControl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'

class SetDefault extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            value: this.props.pathId ? this.props.pathId.join(',') : null
        }
    }

    handleChange = (e) => {
        if (e.target.checked) {
            this.setState({ value: null })
        } else {
            this.setState({ value: this.props.options[0].id })
        }
    }

    handleSave = () => {
        const value = this.state.value ? this.props.options.find(item => item.id === this.state.value).pathId : null
        this.props.handleSave(this.props.fieldId, value)
        this.props.handleClose()
    }

    render() {
        const { intl } = this.props

        return (
            <React.Fragment>
                <DialogTitle>
                    {intl.formatMessage({id: "table.field_default_value"})}
                </DialogTitle>
                <DialogContent>
                    <span style={{lineHeight: '1.5'}}>
                        {intl.formatMessage({id: "table.set_default_text"})}
                    </span>
                    <FormControl style={{margin: '20px 0', width: '100%'}} variant="standard">
                        <InputLabel  shrink={true}>
                            {intl.formatMessage({id: "table.set_default_value_from"})}
                        </InputLabel>
                        <Select
                            value={!this.state.value ? '' : this.state.value}
                            disabled={!this.state.value}
                            onChange={(e) => this.setState({value: e.target.value})}
                        >
                            {this.props.options.map((item, index) =>
                                <MenuItem key={item.id} value={item.id}>{item.pathName}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!this.state.value}
                                    onChange={this.handleChange}
                                />
                            }
                            label={intl.formatMessage({id: "table.no_default_value"})}
                        />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    <Button onClick={this.handleSave} variant="contained" color="primary">
                        {intl.formatMessage({id: "app.confirm_save"})}
                    </Button>
                </DialogActions>
            </React.Fragment>
        )
    }
}

export default injectIntl(SetDefault)
